// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__ZpKP2","rootSmall":"AddTileButton_rootSmall__3xSz9"};